<template>
  <div class="table">
    <table cellspacing="0" cellpadding="0">
      <thead class="table__header">
        <tr>
          <th class="table__header--pin"></th>
          <th
            v-for="(name, x) in formattedData.header"
            :class="highlightedColumn === x ? 'table__highlight--header' : ''"
            @mouseover="highlightItem(false, x)"
            @mouseout="highlightItem(false, false)"
          >
            {{ name }}
          </th>
        </tr>
      </thead>

      <tbody class="table__body">
        <tr v-for="(data, name, x) in formattedData.content">
          <th
            :class="highlightedRow === x ? 'table__highlight--header' : ''"
            @mouseover="highlightItem(x, false)"
            @mouseout="highlightItem(false, false)"
          >
            {{ name }}
          </th>
          <td
            v-for="(value, y) in data"
            :class="highlightedRow === x || highlightedColumn === y ? 'table__highlight--item' : ''"
            @mouseover="highlightItem(x, y)"
            @mouseout="highlightItem(false, false)"
          >
            {{ isAuthenticated ? value : '??' }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object
    },
    scale: {
      type: String
    }
  },
  data() {
    return {
      formattedData: {},
      highlightedColumn: false,
      highlightedRow: false
    }
  },
  computed: {
    isAuthenticated () {
      if (this.$store.getters['user/isAuthenticated'] || this.$route.name === 'Embed') {
        return true
      }
      return false
    }
  },
  methods: {
    formatData() {
      let header = []
      let content = {}

      if (this.data) {
        Object.entries(this.data).forEach(row => {
          let [key, value] = row
          header = header.concat(Object.keys(value))
        })

        header = [... new Set(header)]

        Object.entries(this.data).forEach(row => {
          let [key, value] = row
          let fixedKey = key
          let series = []

          if (key === 'Value') {
            fixedKey = this.scale
          }

          header.forEach(checkKey => {
            series.push(value[checkKey] === null || value[checkKey] === undefined ? '-' : value[checkKey])
          })

          content[fixedKey] = series
        })

        this.formattedData = {
          header: header,
          content: content
        }
      }
    },
    highlightItem (x, y) {
      this.highlightedRow = x
      this.highlightedColumn = y
    }
  },
  mounted() {
    this.formatData()
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/app.scss';

.table {
  @include font('content--sm', $white, 0.9);
  height: 498px;
  overflow: auto;
  background-color: $bg-2;

  @media screen and (min-width: $breakpointMd) {
    @include font('content--md', $white, 0.9);
    height: 501px;
  }

  @media screen and (min-width: $breakpointLg) {
    @include font('content--lg', $white, 0.9);
    height: 541px;
  }

  @media screen and (min-width: $breakpointXl) {
    height: 581px;
  }

  table {
    border-bottom: 1px solid rgba($white, 0.1);
    border-right: 1px solid rgba($white, 0.1);
  }

  &__header {
    position: relative;
    z-index: 50;

    &--pin {
      z-index: 51;
      left: 0;
    }

    th {
      position: sticky;
      top: 0;
      background-color: $bg-2;
      font-weight: 400;
      padding: 0.5rem;
      min-width: 6rem;
      text-align: left;
      border-right: 1px solid $black;
      border-left: 1px solid rgba($white, 0.1);
      border-top: 1px solid rgba($white, 0.1);
      border-bottom: 1px solid $black;

      &:first-child {
        border-left: none
      }

      &:last-child {
       // border-right: 0;
      }
    }
  }

  &__body {
    position: relative;
    z-index: 40;

    tr {
      background-color: $bg-4;

      &:last-child td, &:last-child th {
        //border-bottom: 0;
      }
    }

    th {
      position: sticky;
      left: 0;
      background-color: $bg-2;
      font-weight: 400;
      padding: 0.5rem 8px;
      min-width: 8rem;
      text-align: left;
      border-right: 1px solid $black;
      border-left: 1px solid rgba($white, 0.1);
      border-top: 1px solid rgba($white, 0.1);
      border-bottom: 1px solid $black;

      @media screen and (min-width: $breakpointSm) {
        padding: 0.5rem 16px;
        min-width: 10rem;
      }

      &:first-child {
        border-left: none
      }
    }

    td {
      padding: 0.5rem;
      min-width: 6rem;
      text-align: left;
      border-right: 1px solid $black;
      border-left: 1px solid rgba($white, 0.1);
      border-top: 1px solid rgba($white, 0.1);
      border-bottom: 1px solid $black;

      &:hover {
        background-color: lighten($bg-4, 22.5);
        color: $white,
      }

      &:last-child {
        //border-right: none;
      }
    }
  }

  &__highlight {
    &--header {
      background-color: lighten($bg-4, 7.5) !important;
      color: $blue;
    }

    &--item {
      background-color: lighten($bg-4, 7.5);
    }
  }
}

.table::-webkit-scrollbar {
  width: 18px;
  height: 20px;
}

.table::-webkit-scrollbar-track:horizontal {
  background-color: $bg-2;
  border-top: 1px solid $black;
  box-shadow: inset 0px 1px 0px rgba($white, 0.1);
}

.table::-webkit-scrollbar-track:vertical {
  background-color: $bg-2;
  border-left: 1px solid $black;
  box-shadow: inset 1px 1px 0px rgba($white, 0.1);
}

::-webkit-scrollbar-corner {
  background-color: $bg-2;
  border-top: 1px solid $black;
  box-shadow: inset 0px 1px 0px rgba($white, 0.1);
}

.table::-webkit-scrollbar-thumb {
  border-radius: 999px;
  border: 5px solid transparent;
  background-clip: content-box;
  background-color: rgba($black, 0.5);
}

.table::-webkit-scrollbar-thumb:hover {
  border: 3px solid transparent;
}

.table::-webkit-scrollbar-thumb:active {
  background-color: $black;
}

</style>
